// Copyright (c) Bentley Systems
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

export enum ErrorState {
  Forbidden,
  NotFound,
  InternalServerError,
  Unauthorized,
  OtherError,
  NoError,
}

type isErrorState = {
  errorState: ErrorState;
  activityId: string | undefined;
  silent: boolean;
};

const initialState: isErrorState = {
  errorState: ErrorState.NoError,
  activityId: undefined,
  silent: false,
};

export const isErrorSlice = createSlice({
  name: "isError",
  initialState,
  reducers: {
    setIsError: (state, action: PayloadAction<{ errorState: ErrorState; activityId?: string; silent?: boolean }>) => {
      state.errorState = action.payload.errorState;
      state.activityId = action.payload.activityId;
      state.silent = action.payload.silent ?? false;
    },
    clearIsError: () => {
      return { errorState: ErrorState.NoError, activityId: undefined, silent: false };
  },   
  },
});

export const { setIsError, clearIsError } = isErrorSlice.actions;

export const selectIsError = (state: RootState) => state.isError;

export default isErrorSlice.reducer;